import React from "react";
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import { styled } from "@mui/system";
import adminbg from "../assets/adminbg.jpg";
import bankingbgUI from "../assets/bankingbgUI.jpg";
import ecommercebgUI from "../assets/ecommercebgUI.jpg";

// Page Wrapper with White Background
const Section = styled("section")({
  background: "#FFFFFF",
  minHeight: "115vh",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "60px 20px",
  position: "relative",
});

// Gradient Container (Moved Up)
const GradientContainer = styled(Container)({
  background: "linear-gradient(to right, #00c9a7, #0072ff)",
  padding: "50px",
  borderRadius: "20px",
  boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
  maxWidth: "800px",
  textAlign: "center",
  position: "relative",
  marginBottom: "55px",
});



const UIUXDesign = () => {
  return (
    <Section>
      {/* UI/UX Design Main Section */}
      <GradientContainer>
        <Typography variant="h2" sx={{ fontWeight: "bold", color: "#FBFFFE" }}>
          UI/UX Design
        </Typography>
        <Typography variant="body1" sx={{ marginTop: 2, color: "#FBFFFE" }}>
          Master UI/UX design principles and create visually appealing,
          user-friendly interfaces.
        </Typography>
        <Box sx={{ marginTop: 3 }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#FAA916",
              color: "#FBFFFE",
              "&:hover": { backgroundColor: "#e08c00" },
            }}
          >
            Get Started
          </Button>
        </Box>
      </GradientContainer>

      {/* Recommended Projects Section */}
      <Typography
        variant="h3"
        sx={{ fontWeight: "bold", marginBottom: 4, color: "#333" }}
      >
        Recommended Projects
      </Typography>

      <Grid container spacing={4} justifyContent="center" display="flex" flexWrap="nowrap" width="100%">
        {/* Project 1 */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              maxWidth: "420px",
              borderRadius: 3,
              boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="240"
              image={adminbg}
              alt="Dashboard UI"
            />
            <CardContent>
              <Typography variant="h5" component="div" sx={{ fontWeight: "bold" }}>
                Admin Dashboard UI
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "#555" }}>
                A sleek and modern dashboard for managing analytics, users, and
                reports.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Project 2 */}
        <Grid item xs={12} sm={6} md={4} >
          <Card
            sx={{
              width:"420px",
              borderRadius: 3,
              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="240"
              image={bankingbgUI}
              alt="Mobile App UI"
            />
            <CardContent>
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                Mobile Banking App UI
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "#555" }}>
                A user-friendly mobile app interface with seamless navigation
                and vibrant visuals.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Project 3 */}
        <Grid item xs={12} sm={6} md={4} >
          <Card
            sx={{
              width:"420px",
              borderRadius: 3,
              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="240"
              image={ecommercebgUI}
              alt="E-Commerce UI"
            />
            <CardContent>
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                E-Commerce Store UI
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "#555" }}>
                Clean and intuitive shopping experience for online users with
                product filtering.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Section>
  );
};

export default UIUXDesign;
